import React from 'react';
import Modal from 'react-modal';
import './WinModal.css'
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export const WinModal = (props: any) => {
  const modalClassName = props.isOpen ? 'modalWin active' : 'modalWin';
  const { i18n, t } = useTranslation();
  return (
    <Modal
      isOpen={props.isOpen}
      onRequestClose={props.onClose}
      contentLabel="Win Modal"
      ariaHideApp={false}
      className={modalClassName}
    >
      <div className='win'>
        <button onClick={props.onClose} className="close-button">×</button>
        <h1 style={{margin:0, padding:0}}>{t('modal-win.title')}</h1>
        <h1 style={{margin:"15px 0"}}>{t('modal-win.subTitle')}</h1>
        <span>{t('modal-win.streak')}{props.winStreak === 1 ? props.winStreak + t('modal-win.day') : props.winStreak+ t('modal-win.days')}</span>
        <span>{t('modal-win.lives') + props.lifes + "00 HP"}</span>
        <img className='left' src='heim.png'></img>
      </div>
    </Modal>
  );
};